import * as React from "react";
import CustomerList from "../tenant/CustomerList";


export default function CustomersList() {

    const activeTenant = { _id: null, name: "TUTTI" };

    return (
        <CustomerList
            showAll={true}
            activeTenant={activeTenant}
        />
    );

}
